Block = {
	show: function(blocks){
		// console.log('show --------', blocks)
		blocks.each(function(index, el) {
			var delay = $(this).attr('anim-delay') ? $(this).attr('anim-delay') : 0;
			Block.showOne($(this), delay);
		});

	},

	showOne: function(block, delay){
		// console.log('anim-in', block.attr('anim-in'))
		setTimeout(function(){
			block
				.removeClass(block.attr('anim-out'))
				.addClass(block.attr('anim-in'))
				.removeClass('hidden');
		}, delay)
	},

	hide: function(blocks){
		// console.log('hide --------', blocks)
		blocks.each(function(index, el) {
			var delay = $(this).attr('anim-delay') ? $(this).attr('anim-delay') : 0;
			Block.hideOne($(this), delay);
		});
	},

	hideOne: function(block, delay){
		// console.log('anim-out',block, block.attr('anim-out'))
		setTimeout(function(){
			block.each(function(index, el) {
				$(this)
					.removeClass($(this).attr('anim-in'))
					.addClass($(this).attr('anim-out'));
			});
		}, delay)
	}
}
